export default __webpack_public_path__ + "static/media/1718 spice rack side.a2a8a269.png";